import React from 'react';
import { DatePicker } from 'antd';
import { Form } from 'react-bootstrap';
import dayjs from 'dayjs'
import { patch } from './../utility/string'

/* import from view folder */
import Workshops from "../views/dashboard/workshops";

const Search = ({ resource = [], condition, onSubmit }) => {
    const { RangePicker } = DatePicker;

    const intervalPickerHandler = dates => {
        let _source = Object.assign({}, condition);
        
        if (!dates) {
            delete _source.start;
            delete _source.end;
        }
        else {
            // const startDate = `${dates[0].$y}-${dates[0].$M + 1}-${dates[0].$D}`;
            // const endDate = `${dates[1].$y}-${dates[1].$M + 1}-${dates[1].$D}`;
            const startDate = `${dates[0].$y}-${patch(dates[0].$M + 1)}-${patch(dates[0].$D)}`;
            const endDate = `${dates[1].$y}-${patch(dates[1].$M + 1)}-${patch(dates[1].$D)}`;

            _source.start = startDate;
            _source.end = endDate;
        }
        
        onSubmit(_source);
    };

    const changHandler = ({target, target: { name, value }}) => {
        let _source = Object.assign({}, condition);
        
        _source[name] = value;

        onSubmit(_source);
    };

    return (
        <Form className="search-container">
            {
                resource.map(item => (
                    <Form.Group key={ item.key } flex-full={ `${item.type === 'workshops'}` } className='group-item'>
                        <Form.Label>{ item.label }</Form.Label>
                        {
                            item.type === 'select' ?
                            (
                                <Form.Select type={ item.type } name={ item.key } value={ condition[item.key] } onChange={ changHandler }>
                                    <option hidden>{ item.placeholder }</option>
                                    {
                                        item.options?.map(option => (
                                            <option key={ option.value } value={ option.value }>{ option.name }</option>
                                        ))
                                    }
                                </Form.Select>
                            ) :
                            (
                                item.type === 'workshops' ? 
                                <Workshops values={ condition[item.key] } onChange={ changHandler } /> :
                                (
                                    item.type === 'rangePicker' ? 
                                    <RangePicker className='form-picker' placeholder={ ["開始時間", "結束時間"] } value={[condition['start'] ? dayjs(condition['start'], 'YYYY/MM/DD') : '', condition['end'] ? dayjs(condition['end'], 'YYYY/MM/DD') : '']} onChange={ intervalPickerHandler } /> :
                                    <Form.Control type={ item.type } name={ item.key } placeholder={ item.placeholder } value={ condition[item.key] } onChange={ changHandler } readOnly={ item.readOnly || false } />
                                )
                            )
                        }
                    </Form.Group>
                ))
            }
        </Form>
    );
};

export default React.memo(Search);